import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

export default function LoaderSkeleton() {
    return (
        <Stack spacing={1} p={1}>
            <Skeleton variant="text" sx={{ fontSize: '16px' }} />
            <Skeleton variant="circular" width={40} height={40} />
            <Skeleton variant="rectangular" width={210} height={60} />
            <Skeleton variant="rounded" width={210} height={60} />
        </Stack>
    );
}
